import React from 'react';
import classNames from 'classnames';
import { TableCell, Checkbox } from '@material-ui/core';

import Icon from 'src/components/Icon/Icon';

interface MultiCheckboxCellProps {
  checked: boolean,
  onChange: (e) => void, // eslint-disable-line no-unused-vars
  lastCheckbox?: boolean,
  disabled?: boolean,
  statusNumber?: number,
  statusName?: string,
  marketStatus: number,
  marketStatusName: string,
  isScratchedSelectable?: boolean
}

export default function MultiCheckboxCell({
  checked,
  onChange,
  lastCheckbox = false,
  disabled = false,
  statusNumber,
  statusName,
  isScratchedSelectable,
  marketStatus,
  marketStatusName
}: MultiCheckboxCellProps) {

  return (
    <TableCell style={ { width: '30px' } }>
      {
        (statusNumber === 1 || isScratchedSelectable || true) && marketStatus >= 1 && (
          <Checkbox
            name="isSelected"
            color="default"
            className={
              classNames({
                'competitors-table__checkbox-container': true,
                'competitors-table__checkbox-container--last': lastCheckbox,
                'competitors-table__checkbox-container--disabled': disabled
              })
            }
            checked={ checked }
            onChange={ onChange }
            icon={ marketStatus === 1 ? <Icon icon="checkbox" /> : <Icon icon="lockedSquare" className="competitors-table__checkbox--locked" /> }
            disabled={ disabled }
            checkedIcon={
              <Icon
                icon="checked"
                className={
                  classNames({
                    'competitors-table__checkbox': true,
                    'competitors-table__checkbox--disabled' : disabled
                  })
                }
              />
            }
          />
        )
      }

      {
        (statusNumber > 1 && !isScratchedSelectable) && marketStatus > 1 && (
          <>
            <TableCell />
            <TableCell>
              <div className="competitors-table__status">{  marketStatus > 1 ? marketStatusName : statusName }</div>
            </TableCell>
          </>
        )
      }

    </TableCell>
  );
}
